<div class="design-view-content" *ngIf="isFetchingRFCDetails === false">
    <div class="design-view-left-content">
        <mat-tab-group (selectedTabChange)="tabChanged($event)">
            <mat-tab *ngIf="projectType == 1 || projectType == 3">
                <ng-template mat-tab-label>
                    <div class="design-heading"> PCB Design</div>
                </ng-template>
                <!-- <div  class="loader">Loading...</div> -->
                <div *ngIf="isConvertingSVG || !selectedGerberImage" class="la-ball-clip-rotate-multiple la-2x">
                    <div></div>
                    <div></div>
                  </div>
                <div *ngIf="!isConvertingSVG && selectedGerberImage" (mousedown)="onMouseDown($event)" 
                (mousemove)="onMouseMove($event)" 
                (mouseup)="onMouseUp()" 
                (mouseleave)="onMouseLeave()" class="design-Tab-img">
                    <!-- <svg preserveAspectRatio="xMidYMid meet" viewBox="0 0 200 280" width="100%" height="auto" fill="#f2f2f2" [innerHTML]="bypassSecurityTrustHtml(selectedGerber.content)" title="selectedGerber.fileName"></svg> -->
                    <img #pcbCircuitMain class="main-img"  height="100%" width="100%" [src]="selectedGerberImage"
                        alt="Logo">
                        <!-- <canvas id="myCanvas" width="500" height="500" style="border:1px solid #000000;"></canvas> --> 
                </div>
            </mat-tab>

            <mat-tab *ngIf="projectType == 2 || projectType == 3">
                <ng-template mat-tab-label>
                    Mechanical Design
                </ng-template>
                <div class="design-Tab-img">
                    <img class="main-img" [src]="getImagePath + 'circuit1.png'" alt="Logo">
                </div>
            </mat-tab>
        </mat-tab-group>

        <div class="d-flex justify-content-center gap-2 mt-auto">
            <div class="btn-group" role="group" aria-label="Basic mixed styles example">
                <!-- <button type="button" class="btn"><img class="img-control-icon" [src]="getImagePath+'up-arrow.svg'" alt="Logo"></button>
                <button type="button" class="btn"><img class="img-control-icon" [src]="getImagePath+'down-arrow.svg'" alt="Logo"></button> -->
                <button type="button" class="btn" (click)="zoom('out')" [disabled]="scale <= 1"><img class="img-control-icon" [src]="getImagePath+'zoom_out.svg'" alt="Logo" height="30" width="30"></button>
                <button type="button" class="btn" (click)="resetZoom()"><img class="img-control-icon" [src]="getImagePath+'focus.svg'" alt="Logo" height="30" width="30"></button>
                <button type="button" class="btn" (click)="zoom('in')"><img class="img-control-icon" [src]="getImagePath+'zoom_in.svg'" alt="Logo" height="30" width="30"></button>
            </div>

            <div class="page-btn">  
                <button (click)="OnNextStep()" class="btn btn-primary improved-add-btn">Next</button>
            </div>
        </div>
    </div>

    <div class="design-view-right-content">
        <div *ngIf="selectedTabIndex === 0 && (projectType == 1 || projectType == 3)" class="tab-one-right-content">
            <div class="right-padding pb-3">
                <div class="large-text px-3 py-3">PCB Layer Files</div>
                <div *ngFor="let item of mechanicalDesigns" class="view-gallary d-flex flex-column px-3 py-1">
                    <label class="w-100 label-text">Border & Cutouts</label>
                    <div class="p-3 image-set" (click)="onImageClick(item)">
                        <img *ngIf="item.pngDataUrl" [src]="item.pngDataUrl" alt="PNG Image">
                    </div>
                </div>
                <div *ngFor="let item of pcbDesigns" class="view-gallary d-flex flex-column px-3 py-1">
                    <label class="w-100 label-text">{{extractLabel(item.fileName)}}</label>
                    <div class="p-3 image-set" (click)="onImageClick(item)">
                        <img *ngIf="item.pngDataUrl" [src]="item.pngDataUrl" alt="PNG Image">
                    </div>
                </div>
                <label *ngIf="mechanicalDrillDesigns.length != 0" class="w-100 px-3 label-text">Drill</label>
                <div *ngFor="let item of mechanicalDrillDesigns" class="view-gallary d-flex flex-column px-3 py-1">
                    <div class="p-3 image-set" (click)="onImageClick(item)">
                        <img *ngIf="item.pngDataUrl" [src]="item.pngDataUrl" alt="PNG Image">
                    </div>
                </div>
            </div>
        </div>

        <div *ngIf="selectedTabIndex === 1 && (projectType == 2 || projectType == 3)" class="tab-two-right-content">
            <div class="list-header">Mechanical Layer Files</div>
            <mat-list role="list">
                <mat-list-item role="listitem">
                    <a [attr.href]="" class="list-name">2D Drawing Views</a>
                </mat-list-item>
                <mat-list-item role="listitem">
                    <a [attr.href]="" class="list-name">Top View</a>
                </mat-list-item>
                <mat-list-item role="listitem">
                    <a [attr.href]="" class="list-name">Bottom View</a>
                </mat-list-item>
            </mat-list>
        </div>
    </div>
    <!-- <div class="chat-bot-position">
        <img class="" [src]="getImagePath+'chat-bot.svg'" alt="Logo">
    </div> -->
</div>
<div class="design-view-content image-processing" *ngIf="isFetchingRFCDetails === true && uploadGerberFlag === true">
    <img [src]="getImagePath + 'loading.gif'" alt="Loading">
    <p class="identify-text">Identifying uploaded files</p>
    <p class="process-text">Your files are processing.</p>
    <p class="detail-text">You will see the preview of your PCB when<br /> processing is finished.</p>
</div>
<div class="design-view-content image-processing" *ngIf="uploadGerberFlag === false">
    <p class="identify-text">Upload your gerber file</p>
    <p class="process-text">to see the preview of your PCB</p>
    <!-- <p class="detail-text">You will see the preview of your PCB when<br /> processing is finished.</p> -->
</div>
